//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ReportMaterialsTableMobile from './ReportMaterialsTableMobile.vue'
import ReportMaterialsTableDispatcher from './ReportMaterialsTableDispatcher.vue'

export default {
  components: {
    ReportMaterialsTableMobile,
    ReportMaterialsTableDispatcher
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    disabledNote: {
      type: Boolean,
      default: false
    },
    displayRequestMaterialButton: {
      type: Boolean,
      default: false
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    showRowFn: {
      type: Function,
      default: () => {
        return true
      }
    },
    withoutBtns: {
      type: Boolean,
      default: false
    },
    tableName: {
      type: String,
      default: ''
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    showServiceObject: {
      type: Boolean,
      default: true
    },
    showTag: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  methods: {
    onEdit: function (row) {
      this.$emit('edit-item', row)
    },
    onDelete: function (row) {
      this.$emit('delete-item', row)
    },
    onSelectedItems: function (result) {
      this.$emit('selected-items', result)
    },
    onRequestMaterial: function (row) {
      this.$emit('request-material', row)
    }
  }
}

